// extracted by mini-css-extract-plugin
module.exports = {"box":"_b898f0c","column":"_30f5390","row":"_09ac823","box1":"_0e17443","box2":"_4d54792","box3":"_730ac56","box4":"_272da74","box5":"_c108bd4"};